const styles = {
    headerLabel: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: '600',
        color: '#27344E',
        borderBottom: '1px solid #F7F8FC',
        backgroundColor: '#F7F8FC',
    },
    rowLabel: {
        fontFamily: 'Silka_Regular',
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: '400',
        color: '#4D5C71',
        borderBottom: '1px solid #F7F8FC',
        overflowWrap: 'break-word',
        whiteSpace: 'break-spaces',
    },
    tableContainer: {
        margin: 'auto',
        maxHeight: '400px',
        overflowX: 'auto',
        overflowY: 'scroll',
    },
    sortText: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    } as React.CSSProperties,
};

export default styles;
